// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import './Navbar.css';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <nav className={`navbar navbar-expand-lg navbar-dark navbar-custom ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <button 
          className="navbar-toggler ms-auto" 
          type="button" 
          onClick={() => setExpanded(!expanded)}
          aria-expanded={expanded}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${expanded ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <a className="nav-link" href="#inicio" onClick={handleNavClick}>Inicio</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#nosotros" onClick={handleNavClick}>Nosotros</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#productos" onClick={handleNavClick}>Productos</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#proceso" onClick={handleNavClick}>Proceso</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#contacto" onClick={handleNavClick}>Contacto</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;